// Captured source copy and quotes keep their original typography. Only brand
// values come from the platform registry; the surrounding runtime flag does not
// change the identity of the publisher whose evidence we captured.
import { rewriteRetiredEditorialLinks } from "./seo-recovery-policy.mjs";
export function mapSourceStrings(value, transform) {
  if (typeof value === "string") return transform(value);
  if (Array.isArray(value)) return value.map((v) => mapSourceStrings(v, transform));
  if (value && typeof value === "object") return Object.fromEntries(
    Object.entries(value).map(([k, v]) => [transform(k), mapSourceStrings(v, transform)]));
  return value;
}

export function resolveSourceBrandTokens(value, brands) {
  return mapSourceStrings(value, (s) => rewriteRetiredEditorialLinks(s.replace(
    /\{\{source:(publisher|legacy)-(name|host):([\d,]*)\}\}/g,
    (_, publisher, field, capitals) => {
      const text = brands[publisher]?.[field];
      if (!text) throw new Error(`Missing source publisher registry field: ${publisher}.${field}`);
      const upper = new Set(capitals.split(",").filter(Boolean).map(Number));
      return [...text.toLowerCase()].map((c, i) => upper.has(i) ? c.toUpperCase() : c).join("");
    })));
}